import styled from "styled-components";
import {useAppDispatch, useAppSelector} from "../../../hooks";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    FRONT_FIELDS_VIEW_RENDER_TYPE,
    MANAGE_SCHEMA_MODES,
    ManageSchemaModes,
    setFrontSchemaStateField,
    setFrontSchemaTablesMode,
    SHOW_FIELDS_WEIGHT,
    ShowFieldsWeightU
} from "../../../features/schemaManageSlice";
import {ICONS, KeyOfIcons} from "../../CONSTANTS";

type ModeConfig = {
    label: string;
    icon: KeyOfIcons;
};

export const modeMap: Record<ManageSchemaModes, ModeConfig> = {
    view: {
        label: "View Mode",
        icon: "eye",
    },
    edit: {
        label: "Edit Mode",
        icon: "edit",
    },
    add: {
        label: "Add Mode",
        icon: "add",
    },
};

type WeightConfig = {
    label: string;
};

const weightMap: Record<ShowFieldsWeightU, WeightConfig> = {
    main: {
        label: "Основні",
    },
    all: {
        label: "Всі",
    },
};

export default function AsideFrontFieldsSection({selectedTable}: { selectedTable: string }) {

    const conf = useAppSelector(state => state.schemaManage.front.tables[selectedTable].fields);
    const showUndefined = useAppSelector(state => state.schemaManage.front.showUndefined);
    const showFieldsWeight = useAppSelector(state => state.schemaManage.front.showFieldsWeight);
    const showInlineOnly = useAppSelector(state => state.schemaManage.front.showInlineOnly);
    const showDetailedOnly = useAppSelector(state => state.schemaManage.front.showDetailedOnly);
    const showEditableOnly = useAppSelector(state => state.schemaManage.front.showEditableOnly);
    const showNullableOnly = useAppSelector(state => state.schemaManage.front.showNullableOnly);
    const renderType = useAppSelector(state => state.schemaManage.front.renderType);

    let dispatch = useAppDispatch();
    return <Container>
        <div className="modes">
            {MANAGE_SCHEMA_MODES.map(m => <Btn $active={m === conf.mode} className="btn-cmn"
                                               key={m}
                                               onClick={() => dispatch(setFrontSchemaTablesMode({
                                                         table: selectedTable,
                                                         section: "fields",
                                                         mode: m
                                                     }))}>
                <FontAwesomeIcon size={"lg"} icon={ICONS[modeMap[m].icon]} className={'fa-secondary-color-text'}/>
            </Btn>)}
        </div>
        <div className="render-type">
            {FRONT_FIELDS_VIEW_RENDER_TYPE.map(m => <Btn $active={m === renderType} className="btn-cmn"
                                                         key={m}
                                                         onClick={() => dispatch(setFrontSchemaStateField("renderType", m))}>
                <FontAwesomeIcon size={"lg"} icon={ICONS[m]} className={'fa-secondary-color-text'}/>
            </Btn>)}
        </div>
        <div>Фільтри:</div>
        <div className="params">
            <label htmlFor="si">
                <input id="si" type="checkbox" checked={showInlineOnly}
                       onChange={() => dispatch(setFrontSchemaStateField("showInlineOnly", !showInlineOnly))}/>
                Показувати inline
            </label>
            <label htmlFor="sd">
                <input id="sd" type="checkbox" checked={showDetailedOnly}
                       onChange={() => dispatch(setFrontSchemaStateField("showDetailedOnly", !showDetailedOnly))}/>
                Показувати detailed
            </label>
            <label htmlFor="se">
                <input id="se" type="checkbox" checked={showEditableOnly}
                       onChange={() => dispatch(setFrontSchemaStateField("showEditableOnly", !showEditableOnly))}/>
                Показувати editable
            </label>
            <label htmlFor="sn">
                <input id="sn" type="checkbox" checked={showNullableOnly}
                       onChange={() => dispatch(setFrontSchemaStateField("showNullableOnly", !showNullableOnly))}/>
                Показувати nullable
            </label>
            <div>
                Показувати поля:
            </div>
            {SHOW_FIELDS_WEIGHT.map(w => <label htmlFor={w + "-paramsSchema"} key={w}>
                <input type="radio" id={w + "-paramsSchema"} checked={showFieldsWeight === w}
                       onChange={() => dispatch(setFrontSchemaStateField("showFieldsWeight", w))}/>
                {weightMap[w].label}
            </label>)}
            <label htmlFor="su">
                <input id="su" type="checkbox" checked={showUndefined}
                       onChange={() => dispatch(setFrontSchemaStateField("showUndefined", !showUndefined))}/>
                Показувати невизначені
            </label>
        </div>
    </Container>
}

const Container = styled.div`

    display: flex;
    flex-flow: column;
    gap: .5rem;

    border-top: 2px solid var(--secondary-text);
    padding-top: .5rem;

    .render-type {
        display: flex;
        //flex-flow: column;
        gap: .5rem;
    }

    .params {
        display: flex;
        flex-flow: column;
        gap: .5rem;

        & label:hover {
            cursor: pointer;
        }
    }

    .modes {
        display: flex;
        justify-content: center;
        gap: .5rem;
    }

`

const Btn = styled.button<{ $active: boolean }>`
    padding: .5rem;
    width: 50%;
    border-bottom: 2px solid ${props => props.$active ? "var(--secondary-text)" : "transparent"};
`
